/** Build absolute URL for stock product photos. */
export const stockPhotoUrl = (path, bust) => {
  if (!path) return null;
  const raw = String(path).trim();
  if (raw.startsWith('http://') || raw.startsWith('https://')) {
    return bust ? `${raw.split('?')[0]}?v=${bust}` : raw;
  }
  const base = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '')
    || (typeof window !== 'undefined' ? window.location.origin : '');
  let url;
  if (raw.startsWith('/api/')) {
    url = `${base}${raw}`;
  } else {
    url = `${base}/api/uploads/${raw.replace(/^\/+/, '')}`;
  }
  if (bust) {
    url = `${url.split('?')[0]}?v=${bust}`;
  }
  return url;
};

export const photoPathFromUrl = (url) => {
  if (!url) return '';
  const u = String(url).split('?')[0];
  const marker = '/api/uploads/';
  const i = u.indexOf(marker);
  if (i >= 0) return u.slice(i + marker.length);
  if (!u.startsWith('http')) return u.replace(/^\/+/, '');
  return '';
};

export const resolveProductPhotos = (product, bust) => {
  if (!product) return [];
  if (Array.isArray(product.photos) && product.photos.length) {
    return product.photos.map((p) => stockPhotoUrl(p, bust)).filter(Boolean);
  }
  if (product.thumbnail_url) {
    const url = stockPhotoUrl(product.thumbnail_url, bust);
    return url ? [url] : [];
  }
  return [];
};

export const resolveProductPhotoPaths = (product) => {
  if (!product) return [];
  if (Array.isArray(product.photo_paths) && product.photo_paths.length) {
    return product.photo_paths;
  }
  if (Array.isArray(product.photos)) {
    return product.photos.map(photoPathFromUrl).filter(Boolean);
  }
  return [];
};
